import { Box } from '@mentimeter/ragnar-ui/box';

export const MasonryGrid = ({
  numberOfColumns,
  children,
}: {
  numberOfColumns: number;
  children: (columnIndex: number) => React.ReactNode;
}) => {
  return (
    <Box height="auto" width="100%" flexDirection="row">
      {Array.from(Array(numberOfColumns).keys()).map((columnIndex) => (
        <Box
          key={columnIndex}
          flexDirection="column"
          flex={1}
          p={1}
          mr={columnIndex === numberOfColumns - 1 ? 0 : '1.8%'}
          gap={4}
          height="100%"
          maxHeight="100%"
        >
          {children(columnIndex)}
        </Box>
      ))}
    </Box>
  );
};
